import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import AnimateOnScroll from "../AnimateOnScroll/AnimateOnScroll";
import ImageLoader from "../ImageLoader/ImageLoader";
import { useTranslation } from "react-i18next";

const Developers = () => {
  const { t } = useTranslation();

  return (
    <ImageLoader>
      <Container>
        <Row className="section ">
          <Col md={8}>
            <AnimateOnScroll animationType="slideLeft">
              <img
                src="/images/new_32.jpg"
                alt="One Oasis"
                className="fullimg aspect-16-9"
              />
            </AnimateOnScroll>
          </Col>
          <Col
            md={4}
            className="d-flex flex-column justify-content-center greybox"
          >
            <AnimateOnScroll animationType="slideRight">
              <h2>{t("developers_main_title")}</h2>
              <p>{t("developers_main_p")}</p>
            </AnimateOnScroll>
          </Col>
        </Row>
        <Row className="section ">
          <Col md={3}>
            <AnimateOnScroll animationType="slideup">
              <img
                src="/images/building1.jpg"
                alt="One Oasis"
                className="fullimg "
              />
            </AnimateOnScroll>
          </Col>
          <Col md={9} className="d-flex flex-column justify-content-center ">
            <AnimateOnScroll animationType="slideUp">
              <img
                src="/images/itc.png"
                alt="One Oasis"
                className="developer-logo"
              />
              <p>{t("developers_itc_p")}</p>
            </AnimateOnScroll>
          </Col>
        </Row>
        <hr />
        <Row className="section ">
          <Col md={12} className="d-flex flex-column justify-content-center ">
            <AnimateOnScroll animationType="slideup">
              <img
                src="/images/LE.png"
                alt="One Oasis"
                className="developer-logo"
              />
              <p>{t("developers_linkeast_p")}</p>
            </AnimateOnScroll>
          </Col>
        </Row>
        <hr />
        <Row className="section ">
          <Col md={9} className="d-flex flex-column justify-content-center ">
            <AnimateOnScroll animationType="slideUp">
              <img
                src="/images/arch.png"
                alt="One Oasis"
                className="developer-logo"
              />
              <p>{t("developers_arch_p")}</p>
            </AnimateOnScroll>
          </Col>
          <Col md={3}>
            <AnimateOnScroll animationType="slideup">
              <img
                src="/images/building2.png"
                alt="One Oasis"
                className="fullimg "
              />
            </AnimateOnScroll>
          </Col>
        </Row>
        <hr />
        <Row className="section ">
          <Col md={3}>
            <AnimateOnScroll animationType="slideup">
              <img
                src="/images/building5.jpg"
                alt="One Oasis"
                className="fullimg "
              />
            </AnimateOnScroll>
          </Col>
          <Col md={9} className="d-flex flex-column justify-content-center ">
            <AnimateOnScroll animationType="slideUp">
              <img
                src="/images/success.png"
                alt="One Oasis"
                className="developer-logo"
              />
              <p>{t("developers_success_p")}</p>
            </AnimateOnScroll>
          </Col>
        </Row>
        <hr />
        <Row className="section ">
          <Col md={8} className="d-flex flex-column justify-content-center ">
            <AnimateOnScroll animationType="slideUp">
              <img
                src="/images/nan_fung.png"
                alt="One Oasis"
                className="developer-logo"
              />
              <p>{t("developers_nanfung_p")}</p>
            </AnimateOnScroll>
          </Col>
          <Col md={4}>
            <AnimateOnScroll animationType="slideup">
              <img
                src="/images/building4.png"
                alt="One Oasis"
                className="fullimg "
              />
            </AnimateOnScroll>
          </Col>
        </Row>
      </Container>
    </ImageLoader>
  );
};

export default Developers;
